export async function fetchNotifications ({ per_page = 3, page = 1, status = null }) {
    return await axios.get(route('notifications.index'), {
        params: { per_page, page, status },
    });
}
